export default "__VITE_ASSET__CgmWrak4__"